import React from "react";
import LegalDocument from "../components/LegalDocument";
import NavigationButtons from "../components/NavigationButtons";
import { useAuthState } from "../hooks/useAuth";
import { termsDocument } from "../content/legalContent";

const Terms = () => {
  const { user } = useAuthState();

  return (
    <>
      {user && <NavigationButtons />}
      <LegalDocument documentData={termsDocument} />
    </>
  );
};

export default Terms;
